import React from 'react'
import { PiCheck } from 'react-icons/pi'

import { Button } from '../../design-system/Button'
import { RecordCardAction } from '../../design-system/RecordCard'

export interface CardStateActionProps {
  done: boolean
  label: string
  text: string
  onClick: () => void
  /** Done is final: the button is disabled instead of toggling back. */
  oneWay?: boolean
}

/** The right end of a catalogue card's title line: an action that, once taken, shows a check. */
export function CardStateAction({ done, label, text, onClick, oneWay }: CardStateActionProps): React.ReactElement {
  return (
    <RecordCardAction>
      <Button
        size="small"
        variant={done ? 'text' : 'outline'}
        icon={done ? <PiCheck aria-hidden /> : undefined}
        aria-pressed={oneWay ? undefined : done}
        disabled={oneWay && done}
        aria-label={label}
        onClick={(event) => {
          event.stopPropagation()
          onClick()
        }}
        style={{ flex: 'none' }}
      >
        {text}
      </Button>
    </RecordCardAction>
  )
}
